<template>
  <div :id="'chart' + this.uniqueId"></div>
</template>

<script>
const am4core = require("@amcharts/amcharts4/core");
const am4charts = require("@amcharts/amcharts4/charts");
import am4themes_material from "@amcharts/amcharts4/themes/material";

export default {
  components: {},
  props: {
    data: { type: Array },
    headingColumn: { type: String, default: "" },
    dataColumn: { type: String, default: "" },
    xAxisTitle: { type: String, default: "" },
    yAxisTitle: { type: String, default: "" },
  },
  data: function () {
    return {
      total: 0,
      chart: null,
      uniqueId: Math.random().toFixed(2),
    };
  },
  methods: {
    GenerateChart(ID) {
      am4core.useTheme(am4themes_material);

      this.chart = am4core.create(ID, am4charts.XYChart);

      this.chart.data = this.data;
      this.chart.colors.list = [am4core.color("#47d061")];

      let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = this.headingColumn;
      categoryAxis.title.text = this.yAxisTitle;
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 60;
      categoryAxis.renderer.labels.template.horizontalCenter = "right";
      categoryAxis.renderer.labels.template.rotation = -25;

      categoryAxis.renderer.labels.template.adapter.add("dy", function (dy, target) {
        if (target.dataItem && target.dataItem.index & (2 == 2)) {
          return dy + 0;
        }
        return dy;
      });

      let label = categoryAxis.renderer.labels.template;
      label.truncate = false;
      label.tooltipText = `{category}`;
      label.fontSize = 10;
      label.fontWeight = 100;
      label.stroke = new am4core.color("#9d9d9d");

      let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = this.xAxisTitle;

      let series = this.chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = this.dataColumn;
      series.dataFields.categoryX = this.headingColumn;
      series.columns.template.column.cornerRadiusTopLeft = 10;
      series.columns.template.column.cornerRadiusTopRight = 10;
      series.tooltipText = `[{categoryX}: bold]{valueY}[/]`;
      //series.columns.template.fill = am4core.color("#104547");

      var hoverState = series.columns.template.column.states.create("hover");
      hoverState.properties.cornerRadiusTopLeft = 0;
      hoverState.properties.cornerRadiusTopRight = 0;
      hoverState.properties.fillOpacity = 1;

      this.chart.cursor = new am4charts.XYCursor();
    },
    UpdateChartData() {
      this.chart.data = this.data;
      this.chart.validateData();
      this.chart.series.clear();

      let series = this.chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = this.dataColumn;
      series.dataFields.categoryX = this.headingColumn;
      series.columns.template.column.cornerRadiusTopLeft = 10;
      series.columns.template.column.cornerRadiusTopRight = 10;
      series.tooltipText = `[{categoryX}: bold]{valueY}[/]`;
    },
  },
  mounted() {
    this.GenerateChart("chart" + this.uniqueId);
  },
  beforeDestroy() {
    this.chart.dispose();
  },
  watch: {
    data: function () {
      this.UpdateChartData();
    },
  },
};
</script>

<style scoped></style>
